<template>
  <ul>
    <li
      v-for="sub in subCategories"
      :key="sub.code"
      class="mb-4 last:mb-0 first:mt-4"
    >
      <router-link
        v-if="sub.abstractProductList.length"
        :to="{
          name: '/products/abstractProductCode',
          params: {
            abstractProductCode: sub.abstractProductList[0].code,
          },
        }"
        class="text"
        @click="closeMenu"
      >
        {{ sub.name }}
      </router-link>
      <span v-else class="text text-gray">
        {{ sub.name }}
      </span>
    </li>
  </ul>
</template>

<script setup>
const emit = defineEmits({
  "close-mobile-menu": null,
});

defineProps({
  subCategories: {
    type: Array,
    default() {
      return [];
    },
  },
  category: {
    type: Object,
    required: true,
  },
});

const closeMenu = () => {
  emit("close-mobile-menu");
};
</script>

<style lang="scss" scoped></style>
